/*!
 *  (c)(r) 2008-2023 IT-Service Robert Frunzke
 */

import { arr_inArray, htmlspecialchars, str_trim, mj_shorten_text } from './util.js';
import { startProgress, stopProgress } from './progress-util.js';
import { getPreferedMaxDialogWidth, getPreferedMaxDialogHeight, dialogDynWidthFn, dialogDynHeightFn } from './dialog-util.js';
import { confirm_box } from './page-modal.js';
import { mj } from './page-mj.js';
import { jQuery } from '../other/jquery-hooked.js';
import { mjt } from './i18ntexts.js';

import { MDLocale } from './locale-impl.js';

import { createSearchRequest } from './search-request.js';
import { MDObject } from './object-data.js';
import { MTemplates } from './templates.js';
import { MVSearch } from './search.js';


export let MVCollections = function($,mj) {

	function init() {
		// nothing yet
	}

	function getCollectionTooltipText( collection, keep_short ) {
		var tooltip_text = str_trim(collection.attributes.title);
		var attr_note = str_trim(collection.attributes.note);
		if( attr_note.length ) {
			if( keep_short ) {
				attr_note = mj_shorten_text(attr_note,3,256,' […]');
			}
			tooltip_text += '\n\n' + attr_note;
		}
		return tooltip_text;
	}

	function updateCollections() {
		$('#collections').hide();
		$('#collection-select-own,#collection-select-foreign,#collection-select-public').empty().closest('.select').hide();

		// $('#collection-select-own').html('<option value="0">'+mjt('md-object-type-collection-own')+'</option>');
		// $('#collection-select-foreign').html('<option value="0">'+mjt('md-object-type-collection-foreign')+'</option>');
		// $('#collection-select-public').html('<option value="0">'+mjt('md-object-type-collection-public')+'</option>');

		var options_by_type = {
			'own': [
				'<option value="0">'+mjt('md-object-type-collection-own')+'</option>'
			],
			'foreign': [
				'<option value="0">'+mjt('md-object-type-collection-foreign')+'</option>'
			],
			'public': [
				'<option value="0">'+mjt('md-object-type-collection-public')+'</option>'
			],
		};

		MDObject.queryObjectList( 'collection', 'shared', ['own','relation','public'], function( j ) {
			if( !j ) return;
			for( var idx=0; idx<j.length; ++idx ) {
				var collection = j[idx];
				var attributes = collection.attributes;
				var tooltip_text = getCollectionTooltipText(collection,true);
				var option_html = '<option value="'+collection.list_id+'" title="'+htmlspecialchars(tooltip_text,true,true)+'" data-note="'+htmlspecialchars(attributes.note,true)+'">'+htmlspecialchars(attributes.title)+'</option>';

				if( collection.owner_id==mj.user_id ) options_by_type.own.push(option_html);
				else if( collection.owner_id!=mj.user_id && collection.is_public==0 ) options_by_type.foreign.push(option_html);
				if( collection.is_public==1 ) options_by_type.public.push(option_html);
			}
			var has_selectable_collections = false;

			$.each( options_by_type, function( type, options_arr ) {
				var select_elem = $('#collection-select-'+type);

				// NOTE: first array entry is always '<option value="0">..'
				if( options_arr.length > 1 ) {
					options_arr.push('<option value="-1">'+mjt('md-object-type-collection-list')+'</option>');
					has_selectable_collections = true;
				}
				select_elem.html(options_arr);

				if( options_arr.length > 1 ) select_elem.closest('.select').show();

				select_elem
					.off()
					.on('select2:select', function(e) {
						var type = this.dataset.type || null;
						_handleCollectionSelection(type,this);
						_triggerCollectionSelectionLayoutChange();
						e.preventDefault();
					} )
					.select2( {
						'resultsAdapter': $.fn.select2.amd.require('mjSelect2CollectionResultsAdapter'),
						allowClear: true,
						width: 'style' // 'computedstyle',
					} );
			} );

			if( has_selectable_collections ) $('#collections').show();
			_triggerCollectionSelectionLayoutChange();
		} );
	}

	function resetCollections() {
		$('#collection-select-own,#collection-select-foreign,#collection-select-public').val('0').trigger('change.select2');
	}

	function _triggerCollectionSelectionLayoutChange() {
		$('#collections').trigger('mjslayoutchanged');
	}

	function openCollectionListView( type ) {
		var relation = '';
		var style = type;
		if( type==='foreign' ) {
			relation = 'shared';
			style = 'relation';
		}

		$('#collections-list-dialog').dialog('destroy');

		var dlg_title = mjt('md-object-type-collection-public-list','!');
		if( type=='own' ) dlg_title = mjt('md-object-type-collection-own-list','!');
		else if( type=='foreign' ) dlg_title = mjt('md-object-type-collection-foreign-list','!');
		$('#collections-list-dialog').attr('title',dlg_title);

		$('#collections-list-dialog-list').empty();

		MDObject.queryObjectList('collection', relation, style, function(j) {
			if( !j ) return;
			for( var idx in j ) {
				if( !j.hasOwnProperty(idx) ) continue;

				var collection = j[idx];
				var note = collection.attributes.note;
				var item = $('#collections-list-dialog-item-template').clone().removeAttr('id');

				if( note.length > 50 ) {
					note = note.substring(0,50)+'…';
					var tooltip_text = getCollectionTooltipText(collection,true);
					item.find('.item-note').attr('title',tooltip_text);
				}
				if( ( style==='relation' || style==='public' ) && collection.owner_data && collection.owner_data['display-name'] ) {
					item.find('.item-creator').append( collection.owner_data['display-name'] );
				} else {
					item.find('.item-creator').hide();
				}
				item.find('.item-created').append(MDLocale.fmt_datetime(collection.ctime));
				item.find('.item-changed').append(MDLocale.fmt_datetime(collection.mtime));
				item.find('.item-note').text(note);
				item.find('.item-title').text(collection.attributes.title).attr('title','ID '+collection.object_id);

				item.data('id',collection.object_id);
				item.data('title',collection.attributes.title);

				item.find('.edit-item').prop('disabled',true).addClass('disabled');
				item.find('.share-item').prop('disabled',true).addClass('disabled');
				item.find('.delete-item').prop('disabled',true).addClass('disabled');
				item.show();
				if( collection.owner_id==mj.user_id ) {
					item.find('.edit-item').prop('disabled', false).removeClass('disabled');
					item.find('.delete-item').prop('disabled', false).removeClass('disabled');
					if( collection.is_public==='0' && mj.role_user ) item.find('.share-item').prop('disabled',false).removeClass('disabled');
				} else {
					if( collection.is_public==='0' ) item.find('.delete-item').prop('disabled',false).removeClass('disabled');
					MDObject.hasObjectRelation(collection.object_id, 'shared', 'modify', function( hr ) {
						if( hr ) item.find('.edit-item').prop('disabled',false).removeClass('disabled');
					});
				}
				$('#collections-list-dialog-list').append(item);
			}

			$('#collections-list-dialog-list')
				.off('.mjMVCollections')
				.on('click.mjMVCollections','.select-item,.edit-item,.share-item,.delete-item', function(e) {
					var self = $(this);
					if( self.hasClass('disabled') ) return;
					var collection_item = self.closest('.collection-item');
					var collection_id = collection_item.data('id');

					if( self.hasClass('select-item') ) {

						MDObject.queryObject('collection', collection_id, function(j) {
							$('#collections-list-dialog').dialog('destroy');
							$('#collection-select-'+type).val(collection_id).trigger('change.select2');
							_triggerCollectionSearchRequest(j.attributes.search.search_info,collection_id,collection_item.data('title'), type);
						});

					} else if( self.hasClass('edit-item') ) {

						MDObject.queryObject('collection', collection_id, function( j ) {
							openCollectionEditView( j.attributes.search.search_info, collection_item.data('title'), collection_id, 0, function() {
								openCollectionListView(type);
							} );
						});

					} else if( self.hasClass('share-item') ) {

						openCollectionShareView(collection_id);

					} else if( self.hasClass('delete-item') ) {

						var on_remove_done = function() {
							collection_item.remove();
						};
						MDObject.queryObject('collection', collection_id, function(j) {
							if( j.owner_id===mj.user_id ) {
								confirm_box( mjt('md-object-type-collection-list-delete-confirm-title'), mjt('md-object-type-collection-list-delete-confirm'), function() {
									MDObject.deleteObject('collection', collection_id, on_remove_done );
								} );
							} else {
								confirm_box( mjt('md-object-type-collection-list-unshare-confirm-title'), mjt('md-object-type-collection-list-unshare-confirm'), function() {
									MDObject.deleteObjectRelation( collection_id, 'shared', mj.user_id, on_remove_done );
								} );
							}
						});
					}
				} );

			$('#collections-list-dialog')
				.dialog(
					{
						width: dialogDynWidthFn(300,800),
						height: dialogDynHeightFn(),
						modal: true,
						resizable: false,
						//open: function(ev,ui) {
						//},
						close: function(ev, ui) {
							$(this).dialog('destroy');
							updateCollections();
						},
					}
				).show();
		} );
	}

	function _createCollectionSearchRequest( search_info, object_id, transient_title, type ) {
		var tmp_search_info_obj = createSearchRequest(search_info);
		tmp_search_info_obj.setTransientTitle(transient_title);
		tmp_search_info_obj.setObjectId(object_id);
		if(type) tmp_search_info_obj.setAdditionalData({sub: "collection", target: type});
		return tmp_search_info_obj;
	}

	function _triggerCollectionSearchRequest( search_info, object_id, transient_title, type) {
		var tmp_search_info_obj = _createCollectionSearchRequest(search_info,object_id,transient_title, type);
		MVSearch.triggerSearchByRequestObject(tmp_search_info_obj,true,function _search_done() {
			MVSearch.setFocus();
		},true,true,true,false);
	}

	function _handleCollectionSelection( type, select_elem ) {
		var selected_value = $(select_elem).val();
		if( type==='own' ) {
			$('#collection-select-foreign,#collection-select-public').val('0').trigger('change.select2');
		} else if( type==='foreign' ) {
			$('#collection-select-own,#collection-select-public').val('0').trigger('change.select2');
		} else {
			$('#collection-select-own,#collection-select-foreign').val('0').trigger('change.select2');
		}
		if( selected_value <= 0 ) $('#collection-select-'+type).val('0').trigger('change.select2');
		if( selected_value == -1 ) {
			// NOTE: MVCollections.openCollectionListView() will load required html template (just openCollectionListView() wont)
			MVCollections.openCollectionListView(type);
		} else if( parseInt(selected_value) > 0 ) {
			var selected_title = $('option[value='+selected_value+']',select_elem).text();
			MDObject.queryObject('collection', selected_value, function(j) {
				_triggerCollectionSearchRequest(j.attributes.search.search_info,selected_value,selected_title, type);
			});
		}
	}


	function openCollectionEditView( search_info, guessed_title, preset_id, old_id, on_submit ) {
		if( typeof old_id === 'undefined' ) old_id = 0;

		var col_dialog = $('#collections-create-dialog').dialog('destroy'),	// NOTE: first destroy, then setup dialog contents (else the focus handling will be messed up)
			col_select = $('#collections-create-dialog-step-1-select'),
			col_title = $('#collections-create-dialog-step-2-title');

		var col_share_list = $('#collections-create-dialog-step-3-share-list');


		// load list of users available for sharing:
		// - cheap solution: just wait until user list is loaded completely ...
		// - however, the list stays in memory cache and is re-used.
		// - TODO: use promises + async/await to handle loading user list in background
		MDObject.queryUsersAvailableForObjectSharingRelation( function( users_available_for_sharing ) {


			function reset_sharing_options() {
				$('#collections-create-dialog-step-3-share .collections-create-dialog-step-3-options')
					.prop('disabled',false)
					.prop('checked',false);
				if( !mj.role_user ) $('#collections-create-dialog-step-3-options-shared').prop('disabled',true);
				if( !mj.role_administrator ) $('#collections-create-dialog-step-3-options-public').prop('disabled',true);
			}


			function setup_collection_create_dialog( preset_id, old_id ) {
				col_select.empty();
				col_dialog.data('owner_id', 0);
				$('#collections-create-dialog-step-2,#collections-create-dialog-step-3,#collections-create-dialog-step-3-share-list-div').hide();
				$('#collections-create-dialog-save').prop('disabled',true);

				$('#collections-create-dialog-step-3-share .collections-create-dialog-step-3-options')
					.off()
					.on( 'click', function(e) {
						var type = $(this).val();
						col_share_list.toggle(type==='shared');
					} );

				col_share_list
					.mjWidget('destroy')
					.empty()
					.data('save_option',{})
					.mjWidget( {
						type: 'list',
						values: users_available_for_sharing,
						multiple: true,
						width: '100%',
						select2_options: {
							containerCssClass: 'collectionusersharing',
							dropdownParent: $('#page'),
							templateResult: function( item, li ) {
								if( item && item.element && item.element.style.cssText.length ) li.style.cssText = item.element.style.cssText;
								if( item.loading ) return item.text;
								var term = window._mj_cur_select2_query.term || '';
								var spanClassName = item.class || '';
								if( item && item.element ) {
									// var optionClassNames = item.element.className || '';
									var optionClassNames = 'multiselect collectionusersharing';
									if( optionClassNames!=='' ) li.className = li.className+' '+optionClassNames;
								}
								return window._mj_select2_markMatch(item.text,term,spanClassName);
							}
						}
					} )
					.hide();

				// queryUsersAvailableForSharing( function( users_available_for_sharing ) {
				// 	console.log({ what:'queried list of POSSIBLE users available for initialization of col_share_list', users_available_for_sharing });
				// 	col_share_list.mjWidget('add',users_available_for_sharing);
				// } );

				reset_sharing_options();

				col_title.val(guessed_title).prop('disabled',false);
				$('#collections-create-dialog-step-2-note').val('');
				if( preset_id==0 ) {
					startProgress();
					$.postJSON( 'json/object/relation-objectlist', { type:'collection', relation_type:'shared', option:'modify', listfilter:['own','relation'] }, function(j) {
						stopProgress();
						var own = [];
						var foreign = [];
						for( var id in j ) {
							if( !j.hasOwnProperty(id) ) continue;
							var obj = { id: id, text: j[id].attributes.title, title: j[id].attributes.note };
							if( j[id].owner == mj.user_id ) own.push(obj);
							else foreign.push(obj);
						}
						var data = [
							{ id: '0', text: mjt('md-object-type-collection-create-dialog-step1-select1','!') },
							{ id: '-1', text: mjt('md-object-type-collection-create-dialog-step1-select2','!') },
							{ text: mjt('md-object-type-collection-create-dialog-step1-select-own','!'), children: own },
							{ text: mjt('md-object-type-collection-create-dialog-step1-select-foreign','!'), children: foreign },
						];
						col_select.select2({ data })
							.trigger('change.select2')
							.nextAll('.select2').css('width','100%').end()
							.select2('focus'); // ui dialogs autofocus did not work here - so set explicitely !?
					});
				} else {
					var data = [
						{ id: '-1', text: mjt('md-object-type-collection-create-dialog-step1-select2','!') },
						{ id: preset_id, text: guessed_title },
					];
					col_select.select2({ data })
						.val(preset_id)
						.trigger('change')
						.nextAll('.select2').css('width','100%').end()
						.select2('focus'); // ui dialogs autofocus did not work here - so set explicitely !?
				}

			} // function setup_collection_create_dialog( preset_id, old_id )


			var tmp_search_info_obj0 = _createCollectionSearchRequest(search_info,preset_id,guessed_title);
			var tmp_search_info_obj = tmp_search_info_obj0.normalized().withCategoriesInflated();
			tmp_search_info_obj.inflateOptions(
				function _query_title( o_cfg ) {
					var opts = mj.search.extended_options,
						ol = opts.length,
						i, opt;
					for( i=0; i<ol; ++i ) {
						opt = opts[i];
						if( opt.meta_id==o_cfg.meta_id && opt.type===o_cfg.type ) return opt.title;
					}
					return null;
				},
				function _query_display_value( o_cfg, v ) {
					var mfw_elem = $('#sopts-content > .sopts-item-'+o_cfg.meta_id+' > .es-item');
					if( mfw_elem.length ) return mfw_elem.mjMetaFilterWidget('format',v);
					return null;
				}
			);

			col_title
				.off()
				.on('input', function() {
					if( str_trim($(this).val()).length != 0 ) {
						$('#collections-create-dialog-step-3').show();
						$('#collections-create-dialog-save').prop('disabled',false);
					} else {
						$('#collections-create-dialog-step-3').hide();
						$('#collections-create-dialog-save').prop('disabled',true);
					}
				});

			col_select
				.off()
				.on('change', function() {
					var cval = parseInt(str_trim(col_select.val()),10);

					if( cval === -1 ) {
						// save as new collection ...

						$('#collections-create-dialog-step-2').show();
						$('#collections-create-dialog-step-2-note').val('').trigger('input');

						var new_title = guessed_title;
						if( preset_id!=0 ) {
							new_title += ' '+mjt('md-object-type-collection-create-edit-copy','!');
						} else if( old_id!=0 ) {
							//new_title += ' '+mjt('md-object-type-collection-create-edit-copy-of','!').replace(/%1/,old_id).replace(/%2/,guessed_title);// ' ('+old_id+')';
							new_title += ' '+mjt('md-object-type-collection-create-edit-copy','!');
							$('#collections-create-dialog-step-2-note').val(mjt('md-object-type-collection-create-edit-copy-of','!').replace(/%1/,old_id).replace(/%2/,guessed_title)).trigger('input');
						}

						col_title.val(new_title)
							.trigger('input')
							.focus()
							.select();

						window.setTimeout( function() {
							col_title.focus().select();
						}, 24 );

						reset_sharing_options();

						$('#collections-create-dialog-step-3-options-own').prop('checked',true);

						col_dialog.data('owner_id',0);
						col_share_list.mjWidget('set',[]).hide();

					} else if( cval === 0 ) {

						setup_collection_create_dialog(preset_id,old_id);

					} else if( cval > 0 ) {

						MDObject.queryObject('collection',cval,function(j) {
							if( j ) {
								$('#collections-create-dialog-step-2,#collections-create-dialog-step-3').show();
								$('#collections-create-dialog-save').prop('disabled',false);
								$('#collections-create-dialog-step-2-note').val(j.attributes.note).trigger('input');

								col_title.val(j.attributes.title)
									.trigger('input')
									.focus().select();

								col_dialog.data('owner_id',j.owner_id);
								col_share_list.mjWidget('set',[]);

								reset_sharing_options();

								if( j.is_public==1 ) {
									$('#collections-create-dialog-step-3-options-public').prop('checked',true);
									col_share_list.hide();
								}
								if( j.owner_id!=mj.user_id ) {
									$('#collections-create-dialog-step-2-note').select();
									col_title.prop('disabled',true);
									$('.collections-create-dialog-step-3-options:checked').prop('checked',false);
									$('.collections-create-dialog-step-3-options').prop('disabled',true);
								} else {

									MDObject.queryObjectRelations( 'collection', parseInt(col_select.val()), 'shared', function(k) {
										var shared_to_user_ids_arr = [];
										//var save_option = {};
										for( var user_id in k.relation_items ) {
											if( !k.relation_items.hasOwnProperty(user_id) ) continue;
											shared_to_user_ids_arr.push(user_id);
											// var relation_options = k.relation_items[user_id];
											// if( relation_options.length ) {
											// 	// TODO: just "save_option = k.relation_items;" should do it, right?
											// 	save_option[user_id] = relation_options;
											// }
										}
										var has_relations = shared_to_user_ids_arr.length!==0;
										if( j.is_public==0 ) {
											$('#collections-create-dialog-step-3-options-'+(has_relations?'shared':'own')).prop('checked',true);
										}

										var save_option = Object.assign({},k.relation_items);

										// // eslint-disable-next-line
										// console.log({ what:'NEW queried relations after change on col_select', k, shared_to_user_ids_arr, save_option, 'show share_list': j.is_public==0 && has_relations });

										col_share_list
											.toggle( j.is_public==0 && has_relations )
											.mjWidget('set',shared_to_user_ids_arr)
											.data('save_option',save_option);
									} );

								}
							}
						});
					}
				});

			$('#collections-create-dialog form')
				.off()
				.submit( function(e) {
					var title = col_title.val();
					var note = $('#collections-create-dialog-step-2-note').val();
					var is_public = !!$('#collections-create-dialog-step-3-options-public').prop('checked');
					var is_shared = !!$('#collections-create-dialog-step-3-options-shared').prop('checked');

					var clean_search_info = createSearchRequest(search_info).deflatedForURLRequest().getState();
					var attributes = {
						title: title,
						note: note,
						type: 'search',
						search: { search_info:clean_search_info },
					};
					var collection_id = parseInt(col_select.val(),10);

					function on_after_submit() {
						updateCollections();
						if( on_submit ) on_submit();
					}

					var relation_items = {};

					if( collection_id == -1 ) {
						// new
						if( is_shared ) {

							let share_to_user_ids_arr = col_share_list.mjWidget('get');
							$.each( share_to_user_ids_arr, function(i,k) {
								relation_items[k] = [];
							});

							// // eslint-disable-next-line
							// console.log({what:'will create new collection, shared',share_to_user_ids_arr,relation_items})

						}
						MDObject.createObjectAndRelations('collection', attributes, null, is_public, 'shared', relation_items, function() {
							on_after_submit();
						});

					} else if( collection_id > 0 ) {
						// update
						if( col_dialog.data('owner_id')==mj.user_id ) {
							// update relation_items too
							if( is_shared ) {

								let share_to_user_ids_arr = col_share_list.mjWidget('get');
								var save_option = col_share_list.data('save_option');
								$.each( share_to_user_ids_arr, function(i,k) {
									relation_items[k] = ( save_option[k] != undefined ) ? save_option[k] : [];
								} );

								// // eslint-disable-next-line
								// console.log({what:'will update existing collection, shared',share_to_user_ids_arr,save_option,relation_items})

							} else {
								// NOTE: this will remove existing relations for non-shared collections
							}
							MDObject.updateObjectPropertiesAndRelations('collection', collection_id, attributes, false, null, is_public, 'shared', relation_items, function(j) {
								on_after_submit();
							});
						} else {
							MDObject.updateObjectProperties('collection', collection_id, attributes, false, null, is_public, function(j) {
								on_after_submit();
							});
						}
					}
					col_dialog.dialog('destroy');
					return false;
				} );

			setup_collection_create_dialog(preset_id,old_id);

			col_dialog
				.dialog(
					{
						width:		function(win_size) {
							return Math.min(getPreferedMaxDialogWidth()-40,800);
						},
						height:		function(win_size) {
							return Math.min(getPreferedMaxDialogHeight()+0,800);
						},
						modal:		true,
						resizable:	false,
						close:		function(ev, ui) {
							$(this).dialog('destroy');
						},
					}
				).show();

		} );
	}



	function openCollectionShareView( collection_id ) {

		function setup_share_dialog( j ) {

			$('#collections-share-dialog').dialog('destroy');
			$('#collections-share-dialog-list').empty();
			//$('#collections-share-dialog-step-1-select').empty().select2();
			var dataselect = [
				{ id: -1, text: mjt('md-object-type-collection-share-dialog-step1-placeholder','!'), selected: true },
			];
			for( var idx=0; idx<j.user_ids.length; idx++ ) {
				var pers_id = j.user_ids[idx];
				if( pers_id == mj.user_id ) continue;
				var obj = { id: pers_id, text: j.users[pers_id]['display-name'], selected: false, disabled: false };
				if( j.users[pers_id].relation ) {
					var item = $('#collections-share-dialog-item-template').clone();

					var item_html = '<li><label>';
					item_html += '<input type="checkbox" data-option="modify" '+(arr_inArray('modify',j.users[pers_id].relation_options)!=-1?'checked':'')+'>';
					item_html += MDObject.getObjectRelationOptionTranslation('collection','shared','modify');
					item_html +='</label></li>';

					item.removeAttr('id');
					item.show();
					item.find('.item-username').text(obj.text);
					item.data('id', pers_id);
					item.find('.item-option-list').append(item_html);
					$('#collections-share-dialog-list').append(item);
					obj.disabled = true;
				}
				dataselect.push(obj);
			}
			$('#collections-share-dialog-step-1-select').empty().select2({ data: dataselect });
			$('#collections-share-dialog-step-1-select').off().on('change', function(ev) {
				var pers_id = parseInt($(this).val());
				if( pers_id > 0 ) {
					var items = $('#collections-share-dialog-list').find('.collection-item');
					for( var idx=0; idx<items.length; ++idx ) {
						if( $(items[idx]).data('id')==pers_id ) return;
					}
					var pers_data =$('option[value='+pers_id+']', this).text();
					var item = $('#collections-share-dialog-item-template').clone();

					var item_html = '<li><label>';
					item_html += '<input type="checkbox" data-option="modify">';
					item_html += MDObject.getObjectRelationOptionTranslation('collection','shared','modify');
					item_html += '</label></li>';

					item.removeAttr('id');
					item.show();
					item.find('.item-username').text(pers_data);
					item.data('id', pers_id);
					item.find('.item-option-list').append(item_html);
					$('#collections-share-dialog-list').append(item);
					$('option[value='+pers_id+']',this).prop('disabled',true);
					$('#collections-share-dialog-step-1-select').val(-1).trigger('change.select2');
					return false;
				}
			} );

			$('#collections-share-dialog-list').off().on('click','.delete-item', function() {
				var pers_id = $(this).closest('.collection-item').data('id');
				$('#collections-share-dialog-step-1-select')
					.find('option[value='+pers_id+']').prop('disabled',false).end()
					.trigger('change.select2');
				$(this).closest('.collection-item').remove();
			});

			$('#collections-share-dialog form').off().submit(function() {
				var relation_items = {};
				$('#collections-share-dialog-list').find('.collection-item').each( function() {
					var options = [];
					$(this).find('input[type=checkbox]').filter(':checked').each( function() {
						options.push($(this).data('option'));
					});
					relation_items[$(this).data('id')] = options;
				} );
				MDObject.updateObjectRelations($('#collections-share-dialog').data('id'), 'shared', relation_items, function() {
					$('#collections-share-dialog').dialog('close');
				});
				return false;
			});
		}


		$('#collections-share-dialog').data('id',collection_id);

		MDObject.queryObjectRelationsOLD( 'collection', collection_id, 'shared', function( j ) {

			setup_share_dialog(j);

			$('#collections-share-dialog')
				.dialog(
					{
						width: dialogDynWidthFn(300,800),
						height: dialogDynHeightFn(),
						modal: true,
						resizable: false,
						close: function(ev, ui) {
							$(this).dialog('destroy');
						},
					}
				).show();
		} );

	}


	return {
		init: init,
		updateCollections: updateCollections, //MTemplates.queryDialogHTMLWrappedFn( 'form_media_collections', updateCollections ),
		resetCollections: resetCollections,
		openCollectionListView: MTemplates.queryDialogHTMLWrappedFn( 'form_media_collections', openCollectionListView ),
		openCollectionEditView: MTemplates.queryDialogHTMLWrappedFn( 'form_media_collections', openCollectionEditView ),
		openCollectionShareView: MTemplates.queryDialogHTMLWrappedFn( 'form_media_collections', openCollectionShareView ),
	};

}(jQuery,mj); // namespace MVCollections


// support for onclick="MVCollections....",
window.MVCollections = MVCollections;
